module.exports = __webpack_public_path__ + "img/chevron-right-solid.432555e2.svg";